import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Switch } from "@/components/ui/switch";
import { api, errMsg } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

export const InviteRemindersCard = ({ Card }) => {
  const { settings, setSettings } = useAuth();
  const [cfg, setCfg] = useState(null);
  useEffect(() => { if (settings && !cfg) setCfg(settings.invite_reminders || { enabled: true, days: 3, max: 2 }); }, [settings]); // eslint-disable-line react-hooks/exhaustive-deps
  if (!cfg) return null;
  const save = async () => {
    try { const r = await api.put("/settings/invite-reminders", { enabled: cfg.enabled, days: Number(cfg.days), max: Number(cfg.max) }); setSettings(r.data); toast.success("Reminder settings saved"); }
    catch (e) { toast.error(errMsg(e)); }
  };
  const num = (k, label, max) => (
    <div className="flex items-center justify-between gap-4 rounded-lg border border-slate-800 bg-slate-950/40 px-4 py-2.5">
      <span className="text-sm">{label}</span>
      <Input data-testid={`invite-reminders-${k}`} type="number" min="1" max={max} value={cfg[k]} onChange={(e) => setCfg((c) => ({ ...c, [k]: e.target.value }))} className="bg-slate-950/60 border-slate-700 num w-20 h-9" />
    </div>
  );
  return (
    <Card title="Request form reminders" testId="settings-invite-reminders">
      <div className="grid grid-cols-1 sm:grid-cols-3 gap-3 items-center">
        <label className="flex items-center gap-3 rounded-lg border border-slate-800 bg-slate-950/40 px-4 py-3 text-sm"><Switch data-testid="invite-reminders-enabled" checked={cfg.enabled} onCheckedChange={(v) => setCfg((c) => ({ ...c, enabled: v }))} />Send automatically</label>
        {num("days", "Days before each reminder", 60)}
        {num("max", "Max reminders", 10)}
      </div>
      <div className="flex items-center justify-between gap-4 mt-4">
        <p className="text-xs text-slate-500">Emailed request forms that haven't been submitted get a friendly reminder after this many days, up to the max. Checked every hour.</p>
        <Button data-testid="invite-reminders-save" onClick={save} className="shrink-0 rounded-full bg-emerald-500 text-emerald-950 hover:bg-emerald-400">Save</Button>
      </div>
    </Card>
  );
};
